import { render, staticRenderFns } from "./RoundCheckbox.vue?vue&type=template&id=226574f0&scoped=true"
import script from "./RoundCheckbox.vue?vue&type=script&lang=js"
export * from "./RoundCheckbox.vue?vue&type=script&lang=js"
import style0 from "./RoundCheckbox.vue?vue&type=style&index=0&id=226574f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226574f0",
  null
  
)

export default component.exports